<ifc-file-upload-status *ngIf="tempIfcFiles || tempIfcFileErrors"
  [tempIfcFiles]="tempIfcFiles"
  [tempIfcFileErrors]="tempIfcFileErrors"
  (clearErrorEvent)="clearError($event)">
</ifc-file-upload-status>
<div>
  <mat-card>
    <mat-card-content>
      <mat-form-field>
        <mat-label>Product</mat-label>
        <mat-select [(value)]="selectedProduct" (selectionChange)="productChange($event)">
          <mat-option *ngFor="let product of products" [value]="product">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div class="m-r-10 chart-select-color" [style.background-color]="product.productColor"></div><div>{{product.product}}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>
  </mat-card>
</div>
<div class="analytics" fxLayout="row" fxLayout.lt-md="column">
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <chart
      title="Render Time"
      [subtitle]="true"
      [type]="'bar'"
      [data]="renderChartData"
      [labels]="renderChartLabels"
      [colors]="renderChartColors"
      [loading]="renderChartLoading"
      (chartClick)="handleChartClick($event)"
      [labelFormatter]="labelFormatter"
      [isDarkMode]="isDarkMode">
      <span [style.color]="selectedProduct?.productColor">{{ selectedProduct?.product }}</span> estimated render time is <span [style.color]="selectedProduct?.productColor">{{ getEstimatedRenderTime() }}</span>
    </chart>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <chart
      title="Views"
      [subtitle]="true"
      [type]="'bar'"
      [data]="viewsChartData"
      [labels]="viewsChartLabels"
      [colors]="viewsChartColors"
      [loading]="viewsChartLoading"
      (chartClick)="handleChartClick($event)"
      [labelFormatter]="labelFormatter"
      [isDarkMode]="isDarkMode">
      Most popular <strong>{{ capitalizeFirstLetter(home) }}</strong> configurations in the past 24 hours
    </chart>
  </div>
</div>
<div fxLayout="row" fxLayout.lt-md="column">
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>IFC Files</label>
          <button *ngIf="isAdmin" type="button" mat-flat-button color="accent" title="Save" (click)="showUploadFiles()">
            <mat-icon>add</mat-icon> Upload Files
          </button>
        </div>
        <ng-container *ngIf="!selectedIfc">
          <mat-card class="contrast" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <mat-form-field>
                <input matInput type="text"
                  [formControl]="searchField"
                  (keyup)="doFilter($event.target.value)"
                  (keyup.esc)="$event.target.value=''; doFilter('')"
                  placeholder="Filter IFC files by name">
              </mat-form-field>
            </mat-card-content>
          </mat-card>
          <ng-container *ngFor="let item of filteredIfcFileArtifacts; let i = index">
            <mat-card class="contrast card-link" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="selectIfcFile(item)">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
                  <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | highlight: searchField.value"></strong>
                </div>
                <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                  <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                    <button mat-icon-button color="primary" matTooltip="Generate IFC Preview" (click)="$event.stopPropagation(); generateIFCPreview(item)">
                      <mat-icon>preview</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </ng-container>
        <mat-card *ngIf="selectedIfc" class="contrast banner-info" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
              <strong class="text-center highlight" [ngClass.lt-sm]="{'card-title': true}">{{ selectedIfc?.name }}</strong>
            </div>
            <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <button mat-icon-button color="basic" aria-label="Cancel"  (click)="selectIfcFile(undefined)">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <ng-container *ngIf="selectedIfc && !selectedIfcVersion">
          <ng-container *ngFor="let item of selectedIfc.versions">
            <mat-card class="contrast card-link" [class.banner-success]="isRecent(item?.dateAdded)" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="selectIfcFileVersion(item)">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
                  v<strong class="text-center" [ngClass.lt-sm]="{'card-title': true}">{{ item?.version }}</strong>
                </div>
                <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                  <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                    <p><small>date added</small></p>
                    <span class="text-center highlight" [ngClass.lt-sm]="{'card-title': true}">&nbsp;{{ item?.dateAdded | date:'medium' }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </ng-container>
        <mat-card *ngIf="selectedIfc && selectedIfcVersion" class="contrast banner-info" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
              <span>v<strong class="text-center highlight" [ngClass.lt-sm]="{'card-title': true}">{{ selectedIfcVersion?.version }}</strong></span>
            </div>
            <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <p><small>date added</small></p>
                <div class="text-center highlight">&nbsp;{{ selectedIfcVersion?.dateAdded | date:'medium' }}</div>
                <button mat-icon-button color="basic" aria-label="Cancel" (click)="selectIfcFileVersion(undefined);">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <ng-container *ngIf="selectedIfc && selectedIfcVersion && !selectedIfcOption">
          <ng-container *ngFor="let item of ifcOptions">
            <mat-card class="contrast card-link" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="selectIfcOption(item)">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
                  <span class="text-success">{{ getIfcOptionCount(selectedIfcVersion, item) }}&nbsp;</span><strong class="text-center" [ngClass.lt-sm]="{'card-title': true}"> {{ item }}</strong>
                </div>
                <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                  <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </ng-container>
        <mat-card *ngIf="selectedIfc && selectedIfcVersion && selectedIfcOption" class="contrast banner-info" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
              <strong class="text-center highlight" [ngClass.lt-sm]="{'card-title': true}">{{ selectedIfcOption }}</strong>
            </div>
            <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <button mat-icon-button color="basic" aria-label="Cancel" (click)="selectIfcOption(undefined);">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <ng-container *ngIf="selectedIfc && selectedIfcVersion && selectedIfcOption">
          <ng-container *ngFor="let item of options">
            <mat-card class="contrast" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
                  <div class="text-center option-text"> {{ item }}</div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </ng-container>
      </mat-card-content>
  </mat-card>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <ifc-file-list 
      [loading]="ifcFilesLoading"
      [homeIfcFiles]="homeIfcFiles"
      [homeIfcFileErrors]="homeIfcFileErrors"
      [emitSelection]="true"
      (ifcFileSelection)="handleIfcFeedFileSelection($event)">
    </ifc-file-list>
  </div>
</div>